export default "__VITE_ASSET__DwUX70qm__"